export { default as reducer } from "./configuration.ducks";
export * from "./configuration.ducks";
export * from "./hooks";
export * from "./helpers";



// WEBPACK FOOTER //
// ./src/routes/Configuration/index.ts